import {Serializable} from "./serializable";

export class User implements Serializable<User> {

  email: string;
  id: string;
  name: string;
  uid: string;

  deserialize(input: any): User {
    if (!input) return null;

    this.email = input.email;
    this.name = input.name;
    this.uid = input.uid;
    this.id = input.id;
    return this;
  }

}

export interface UserListInt {
  email: string;
  id: string;
  name: string;
  surname: string;
  avatar: string;
  automations: any;
  automations_owner: any;
  circle_invited: any;
  circles_membership: string;
  lan: string;
  scenarios_membership: string;
  user_type: string;
}

export class UserList implements Serializable<UserList> {

  email: string;
  id: string;
  name: string;
  surname: string;
  avatar: { url: string };
  automations: any;
  automations_owner: any;
  circle_invited: any;
  circles_membership: string;
  lan: string;
  scenarios_membership: string;
  user_type: string;

  deserialize(input: any): UserList {
    if (!input) return null;

    this.email = input.email;
    this.name = input.name;
    // this.surname = input.uid;
    this.surname = input.surname;
    this.id = input.id;
    this.avatar = input.avatar;
    this.automations = input.automations;
    this.automations_owner = input.automations_owner;
    this.circle_invited = input.circle_invited;
    this.circles_membership = input.circles_membership;
    this.circles_membership = input.circles_membership;
    this.lan = input.lan;
    this.scenarios_membership = input.scenarios_membership;
    return this;
  }

  flatten(): UserListInt {
    return {
      email: this.email,
      id: this.id,
      name: this.name,
      surname: this.surname,
      avatar: this.avatar.url,
      automations: this.automations,
      automations_owner: this.automations_owner,
      circle_invited: this.circle_invited,
      circles_membership: this.circles_membership,
      lan: this.lan,
      scenarios_membership: this.scenarios_membership,
      user_type: this.user_type
    };
  }

  makeUserType(): UserList {
    if ((this.automations_owner != null && this.automations_owner > 0) && (this.circle_invited != null && this.circle_invited > 0)) {
      this.user_type = "Admin, Ospite";
    } else if ((this.automations_owner != null && this.automations_owner === 0) && (this.circle_invited != null && this.circle_invited === 0)) {
      this.user_type = "";
    } else if ((this.automations_owner != null && this.automations_owner > 0) && (this.circle_invited != null && this.circle_invited === 0)) {
      this.user_type = "Admin";
    } else if ((this.automations_owner != null && this.automations_owner === 0) && (this.circle_invited != null && this.circle_invited > 0)) {
      this.user_type = "Ospite";
    } else {
      this.user_type = "";
    }
    // console.log("USER TYPE:", this.email, this.automations_owner, this.circle_invited, this.user_type);
    return this;
  }

}

export class UserDetail implements Serializable<UserDetail> {

  automations_owner: string;
  avatar: string;
  circles_membership: string;
  email: string;
  id: string;
  lan: string;
  name: string;
  scenarios_membership: string;
  surname: string;
  total_automations: string;
  automations: any;

  deserialize(input: any): UserDetail {
    if (!input) return null;

    this.email = input.email;
    this.name = input.name;
    this.surname = input.surname;
    this.id = input.id;
    this.avatar = input.avatar;
    this.automations_owner = input.automations_owner;
    this.circles_membership = input.circles_membership;
    this.lan = input.lan;
    this.scenarios_membership = input.scenarios_membership;
    this.total_automations = input.total_automations;
    this.automations = input.automations;

    return this;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/user.ts